<script lang="ts">
    import { useNavigate, useLocation } from "svelte-navigator";
    import {isLoggedIn} from "../../store/loginV2";

    const navigate = useNavigate();
    const location = useLocation();

    $: if (!$isLoggedIn) {
        navigate("/", {
            replace: true,
        });
    }
</script>

{#if $isLoggedIn}
    <slot />
{/if}
